export enum Privileges {
    TERM_CONDITIONS_MAINTENANCE_PRIVILEGE = 'TERM_CONDITIONS_MAINTENANCE_PRIVILEGE',
    POLYMER_MAINTENANCE_PRIVILEGE = 'POLYMER_MAINTENANCE_PRIVILEGE',
    SOLVENT_MAINTENANCE_PRIVILEGE = 'SOLVENT_MAINTENANCE_PRIVILEGE',
    USER_MAINTENANCE_PRIVILEGE = 'USER_MAINTENANCE_PRIVILEGE',
    UNRESTRICTED_SEARCH_PRIVILEGE = 'UNRESTRICTED_SEARCH_PRIVILEGE',
    DATA_RESTRICTION_MAINTENANCE_PRIVILEGE = 'DATA_RESTRICTION_MAINTENANCE_PRIVILEGE'
}
